import { getReq } from "./instance";

export const getIngredientGroup = async (
  ingredientGroupId: string,
  params = {},
) => {
  return getReq(`/IngredientGroup/${ingredientGroupId}`, params);
};
